import { newError } from '../errors';
import * as actionTypes from '../../constants/actions';
import { getStore } from '../../../app/store';
import { getComment } from '../../utils/data';
import sendDeleteComment from '../../api/comments/delete';

// Delete comment
const deleteCommentStart = (dispatch) => {
  dispatch({
    type: actionTypes.COMMENTS_DELETE,
    status: 'started',
  });
};

const deleteCommentSuccess = (comment, dispatch) => {
  dispatch({
    type: actionTypes.COMMENTS_DELETE,
    status: 'success',
    comment,
  });
};

const deleteCommentError = (error, dispatch) => {
  dispatch(newError(error, 'deleteComment'));
  dispatch({
    type: actionTypes.COMMENTS_DELETE,
    status: 'error',
    error,
  });
};

const deleteComment = (commentId) => async (dispatch) => {
  if (!commentId) {
    const err = { message: "You need to provide the comments's object id" };
    return deleteCommentError(err, dispatch);
  }

  const store = getStore();
  const comment = getComment(store.getState(), commentId);

  deleteCommentStart(dispatch);

  try {
    await sendDeleteComment({
      commentId,
      postId: comment.post,
    });

    return deleteCommentSuccess(comment, dispatch);
  } catch (err) {
    return deleteCommentError(err, dispatch);
  }
};

export default deleteComment;
